export default {
    lang: {
        name: 'Plays during date range'
    }
}